import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { EditPoolNameField } from '~src/settings/bridge-settings/sections/bridgeMultiPool/EditPoolNameField';

export type PropsForAddBridgePoolDialog = ReactActionDialogBodyProps<
  AddBridgePoolDialogProps,
  AddBridgePoolDialogState
>;

export type AddBridgePoolDialogProps = Readonly<{
  existingPoolNames: string[];
}>

export type AddBridgePoolDialogState = Readonly<{
  poolName: string;
  hasError: boolean;
}>

export function AddBridgePoolDialogBody(props: PropsForAddBridgePoolDialog) {
  const onPoolNameChange = (poolName: string) => {
    props.updateDialogState({ poolName });
  };
  const onHasErrorChange = (hasError: boolean) => {
    props.updateDialogState({ hasError });
  };

  return (
    <EditPoolNameField
      poolName={props.dialogState.poolName}
      onPoolNameChange={onPoolNameChange}
      hasError={props.dialogState.hasError}
      onHasErrorChange={onHasErrorChange}
      existingPoolNames={props.existingPoolNames}
    />
  );
}
